import { useTitleOfCustomLang } from './useTitleOfCustomLang';

import type { CustomizationId } from 'shared/domain';
import type { FullMenuCatalog } from 'features/menu-page/domain';

export function useTitleOfCustom(props: Props) {
  const { customId, catalog } = props;

  const _MAX_LENGTH = 2;

  const cgs =
    catalog.customizationGroups.filter(cg =>
      cg.items.find(i => i.id === customId),
    ) ?? [];
  const _fullNames = cgs.map(
    cg => catalog.products.find(p => p.id === cg.productId)?.name,
  );

  const showNames = cgs.length > 0;
  const names = _fullNames.slice(0, _MAX_LENGTH);
  const fnsLen = _fullNames.length;
  const showRestNames = fnsLen > _MAX_LENGTH;
  const restNamesLength = fnsLen - _MAX_LENGTH;

  const lang = useTitleOfCustomLang();

  return {
    lang,
    showNames,
    showRestNames,
    restNamesLength,
    description: cgs[0]?.description,
    names: names.join(', '),
    restNames: _fullNames.slice(_MAX_LENGTH).join(', '),
  };
}

interface Props {
  customId: CustomizationId;
  catalog: FullMenuCatalog;
}
